import { RiMapPin2Line } from 'react-icons/ri';
import { FiPhone } from 'react-icons/fi';
import { AiOutlineMail } from 'react-icons/ai';


const Contact = () =>{
  return(
    <div
    className="container division3"
    id="contact">
      <h1 className="title-responsive text-center">
        want to ask a question?
      </h1>
      <div className="col-12 division2">
        <div 
        className="d-flex flex-wrap">
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex flex-column align-items-center">
            <FiPhone size={56} />
            <p className="mt-2">
              123-456-789-0
            </p>
          </div>
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex flex-column align-items-center">
            <RiMapPin2Line size={56} />
            <p className="mt-2">
              Chicago city, USA
            </p>
          </div>
          <div className="col-12 col-md-4 mt-4 mt-md-0 d-flex flex-column align-items-center">
            <AiOutlineMail size={56} />
            <p className="mt-2">
              emailaddress@damain.com
            </p>
          </div>
        </div>
        <div className="d-flex flex-wrap mt-4">
          <div className="col-12 mt-4 px-1">
            <input
            type="text"
            className="form-control"
            placeholder="name"
            />
          </div>
          <div className="col-12 mt-4 px-1">
            <input
            type="text"
            className="form-control"
            placeholder="email"
            />
          </div>
          <div className="col-12 mt-4 px-1">
            <input
            type="text"
            className="form-control"
            placeholder="Subject"
            />
          </div>
          <div className="col-12 mt-4 px-1">
            <textarea
            type="text"
            className="form-control"
            placeholder="message"
            />
          </div>
          <div className="d-flex justify-content-end w-100">
            <button className="btn btn-primary btn-lg mt-4">
              send a message
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contact;